import { render } from "./PricingComponent.vue?vue&type=template&id=653e3bb8&scoped=true&ts=true"
import script from "./PricingComponent.vue?vue&type=script&lang=ts"
export * from "./PricingComponent.vue?vue&type=script&lang=ts"

import "./PricingComponent.vue?vue&type=style&index=0&id=653e3bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653e3bb8"]])

export default __exports__